<template>
  <header>
    <nav class="top-nav clearfix">
      <h1 class="brand">
        <a>국어문화학교</a>
      </h1>
      <!-- 상단메뉴 (기본상태) -->
      <ul class="gnb clearfix" v-if="!sysmenu && sysmenuActive">
        <li>
          <router-link to="/users">회원관리</router-link>
        </li>
        <li>
          <router-link to="/classes">강좌관리</router-link>
        </li>
        <li>
          <a>게시판관리</a>
        </li>
        <li>
          <router-link to="/users" class="btn-sm round f-14">강좌만들기</router-link>
        </li>
      </ul>
      <ul class="info-gnb clearfix" v-if="!sysmenu && sysmenuActive">
        <li>
          <a class="btn-sm round">CMS</a>
        </li>
        <li class="mypage">
          <a>마이페이지</a>
        </li>
        <li class="msg">
          <a>메세지</a>
        </li>
        <li class="config">
          <a @click="sysmenu=true">설정</a>
        </li>
      </ul>

      <!-- 상단메뉴 (펼침상태) -->
      <ul class="gnb clearfix" v-if="sysmenu && sysmenuActive">
        <li>
          <router-link to="/categories">교육과정 관리</router-link>
          <ul class="gnb2">
            <li>
              <a>강의개설 초기값</a>
            </li>
            <li>
              <a>설문 초기값</a>
            </li>
            <li>
              <a>교육 안내 설정</a>
            </li>
            <li>
              <a>신청안내 설정</a>
            </li>
            <li>
              <router-link to="/categories">교육과정분류 편집</router-link>
            </li>
          </ul>
        </li>
        <li>
          <router-link to="/permissions">권한 관리</router-link>
          <ul class="gnb2">
            <li>
              <router-link to="/permissions">권한 관리</router-link>
            </li>
            <li>
              <a>권한 편집</a>
            </li>
          </ul>
        </li>
        <li>
          <router-link to="/email/forms">전자우편 관리</router-link>
          <ul class="gnb2">
            <li>
              <router-link to="/email/forms">전자우편 양식 관리</router-link>
            </li>
            <li>
              <a>자동보내기 설정</a>
            </li>
            <li>
              <router-link to="/email/sents">보낸 우편함</router-link>
            </li>
          </ul>
        </li>
        <li>
          <router-link to="/sms/forms">문자 관리</router-link>
          <ul class="gnb2">
            <li>
              <router-link to="/sms/forms">문자 양식 관리</router-link>
            </li>
            <li>
              <a>자동보내기 설정</a>
            </li>
            <li>
              <router-link to="/sms/sents">보낸 문자함</router-link>
            </li>
          </ul>
        </li>
        <li>
          <router-link to="/institutions">강의지원</router-link>
          <ul class="gnb2">
            <li>
              <a>정산 관리</a>
            </li>
            <li>
              <router-link to="/institutions">소속기관 관리</router-link>
            </li>
            <li>
              <a>출력물 관리</a>
            </li>
            <li>
              <a>강의실 관리</a>
            </li>
          </ul>
        </li>
        <li>
          <a>시스템 관리</a>
          <ul class="gnb2">
            <li>
              <a>로그조회</a>
            </li>
            <li>
              <a>코드관리</a>
            </li>
            <li>
              <router-link to="/filters">목록 필터 관리</router-link>
            </li>
          </ul>
        </li>
        <li>
          <a>통계</a>
        </li>
      </ul>
      <ul class="info-gnb clearfix" v-if="sysmenu">
        <li>
          <a class="btn-sm round" @click="close">
            <img src="images/off-setting.png" alt width="15" /> 닫기
          </a>
        </li>
      </ul>
    </nav>
    <nav class="bottom-nav clearfix">
      <div class="inner">
        <slot>
          <h2 class="page-tit half-width">
            <div class="img-add m-r-10">
              <img
                :src="(icon&&(typeof icon=='object'))?'/download/'+icon.atchFileId:((icon&&(typeof icon=='string'))?'/download/'+icon:'http://placehold.it/80x80')"
                width="80"
              />
            </div>
            <small class="text-white m-t-15" v-if="subname">{{subname}}</small>
            {{ name }}
          </h2>
        </slot>

        <div class="search-box" style="margin-top: -25px;" v-if="searchbox">
          <input
            id="search"
            class="form-control round full-width m-b-0"
            type="text"
            ref="searchKeyword"
            v-model="searchKeyword"
          />
          <label for="search" @click="emitSearchKeywordChanged">검색</label>
        </div>
        <ul class="sub-gnb clearfix">
          <li v-for="menu in menus" v-bind:class="{on:menu.selected}" v-bind:key="menu.name">
            <router-link :to="menu.link">{{ menu.name }}</router-link>
          </li>
        </ul>
        <div class="page-btn-box">
          <button
            v-for="button in buttons"
            v-on:click="button.fn"
            v-bind:key="button.name"
            class="btn round"
            type="button"
          >{{ button.name }}</button>
        </div>
      </div>
    </nav>
  </header>
</template>

<script>
export default {
  // 컴포넌트 명
  name: "ClassHeader",
  mounted: function() {
    this.getLoginInfo().then(info => {
      this.auth = info.auth;
    });
  },

  // 이 컴포넌트 내부에서 사용되는 데이터
  data: function() {
    return {
      searchKeyword: "",
      sysmenu: this.mainmenuOpened
    };
  },

  // 컴포넌트 내부 데이터 변경 감시
  watch: {
    searchKeyword: function(newValue) {
      this.emitSearchKeywordChanged(newValue);
    }
  },

  // 부모컴포넌트로부터 전달받는 프로퍼티
  props: {
    name: String,
    subname: String,
    menus: Array,
    buttons: Array,
    mainmenuOpened: Boolean,
    searchbox: Boolean,
    sysmenuActive: {
      type: Boolean,
      default: true
    },
    icon: String
  },

  // 이 컴포넌트에서 사용되는 기능
  methods: {
    emitSearchKeywordChanged: function(keyword) {
      if (this.searchbox) {
        if (!keyword) this.$emit("keywordChanged", this.searchKeyword);
        else this.$emit("keywordChanged", keyword);
      }
    },
    close: function() {
      // eslint-disable-next-line
      // console.log("왜 안닫히는거여");
      this.window.close();
    }
  }
};
</script>

<style scoped>
.bottom-nav {
  overflow: hidden;
}
</style>